import React from 'react';
import { ArrowRight, Check, ShieldCheck, Truck, Clock } from 'lucide-react';
export function CtaSection() {
  return <div className="my-12 p-8 bg-yellow-50 border-2 border-yellow-200 rounded-xl shadow-sm" data-id="element-20">
      <div className="text-center mb-6" data-id="element-21">
        <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-22">
          Update: Limited Stock Alert
        </h3>
        <p className="text-red-600 font-medium animate-pulse" data-id="element-23">
          🔥 High Demand: Only 14 units remaining from this shipment
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-24">
        <div className="w-full md:w-1/3 bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-25">
          <div className="aspect-square bg-gray-100 rounded-md flex items-center justify-center mb-4 relative overflow-hidden" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/f6ZJBqkiCg5gUE9sCBScJL/Headers_Titles.png" alt="Phlora Device Kit" className="object-cover w-full h-full" data-id="element-27" />
            <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-28">
              50% OFF
            </div>
          </div>
          <p className="text-center font-bold text-gray-900" data-id="element-29">
            Phlora Lymphatic Sculptor
          </p>
        </div>

        <div className="w-full md:w-2/3" data-id="element-30">
          <div className="space-y-3 mb-6" data-id="element-31">
            <div className="flex items-center gap-2 text-gray-700" data-id="element-32">
              <Check className="text-green-500 shrink-0" size={20} data-id="element-33" />
              <span data-id="element-34">
                <strong data-id="element-35">50% Discount</strong> applied automatically
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-700" data-id="element-36">
              <Truck className="text-green-500 shrink-0" size={20} data-id="element-37" />
              <span data-id="element-38">
                <strong data-id="element-39">Free Express Shipping</strong> (US Only)
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-700" data-id="element-40">
              <ShieldCheck className="text-green-500 shrink-0" size={20} data-id="element-41" />
              <span data-id="element-42">
                <strong data-id="element-43">90-Day Money-Back Guarantee</strong>
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-700" data-id="element-44">
              <Clock className="text-green-500 shrink-0" size={20} data-id="element-45" />
              <span data-id="element-46">
                <strong data-id="element-47">1-Year Warranty</strong> included
              </span>
            </div>
          </div>

          <div className="flex items-baseline gap-3 mb-6" data-id="element-48">
            <span className="text-4xl font-bold text-gray-900" data-id="element-49">$59.99</span>
            <span className="text-xl text-gray-400 line-through" data-id="element-50">$119.98</span>
          </div>

          <a href="https://www.phloraskin.shop/products/electric-meridian-brush-massage-whole-body-shoulder-and-neck-dredging" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white text-xl font-bold py-4 px-6 rounded-lg shadow-lg transform transition hover:-translate-y-0.5 flex items-center justify-center gap-2 no-underline" data-id="element-51">
            CLAIM YOUR 50% DISCOUNT
            <ArrowRight size={24} data-id="element-52" />
          </a>
        </div>
      </div>

      <div className="text-center text-sm text-gray-500" data-id="element-53">
        <p data-id="element-54">
          Try it risk-free for 90 days. If you don't love it, get a full refund.
        </p>
      </div>
    </div>;
}